module.exports = __webpack_public_path__ + "img/vertical_7_6_8011.a061fa01.png";